import { BACKEND_ROUTES } from "../../backendRoutes";
import useSWRImmutable from "swr/immutable";

export const useBBCHStages = () => useSWRImmutable(BACKEND_ROUTES.BBCH_STAGE);
